import React from 'react'
import { createUseStyles } from 'react-jss'
import ResponsiveImage from '../../ResponsiveImage'
import RichText from '../../RichText'
import { vw } from '../../../style/vw'
import theme from '../../../style/theme'
import { span } from '../../../style/span'

export default function Tile ({ image, title, copy }) {
  const classes = useStyles()
  return (
    <div className={classes.tile}>
      <ResponsiveImage {...image} aspect={290 / 420} showCaption={false} />
      <div className={classes.title}>{title}</div>
      <div className={classes.copy}>
        <RichText content={copy} />
      </div>
    </div>
  )
}

const useStyles = createUseStyles({
  tile: {
    display: 'flex',
    flexDirection: 'column',
    gap: vw(10),
    width: vw(290),
    paddingRight: vw(20),
    [theme.breakpoints.up('md')]: {
      paddingRight: span(1),
      width: span(5, 'md'),
      gap: vw(16, 'desktop')
    }
  },
  title: {
    fontFamily: theme.fonts.headings,
    fontWeight: theme.fonts.headingsFontWeight,
    fontSize: vw(16),
    [theme.breakpoints.up('md')]: {
      fontSize: vw(20, 'desktop')
    }
  },
  copy: {
    whiteSpace: 'wrap',
    fontSize: vw(14),
    [theme.breakpoints.up('md')]: {
      fontSize: vw(16, 'desktop')
    }
  }
})
